export default __webpack_public_path__ + "static/media/logo_green.4ca7e717.svg";